<div class="newsticker-container" #newstickerContainer>
  <ul class="ul-loader">
    <ngx-skeleton-loader
      [theme]="{
        width: '100%',
        height: '100%',
        'margin-bottom': '0',
      }"
    ></ngx-skeleton-loader>
  </ul>
</div>
